import { CategoryFirstLevel } from './../../shared/dtos/category-first-level';
import { OfferDemand } from './../../shared/dtos/offer-demand';
import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { itiPermissionService, store } from '@/iti-core-vue';

import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';
import categoryFirstLevelModule from './category-first-level.module';
import { MatchingOfferDemand } from '@/shared/dtos/matching-offer-demand';
import collaborativeAreaModule from './collaborative-area.module';
import AdvancedSearch from '@/views/advanced-search/advanced-search';
import OfferDemandMatching from '@/views/offers-demands/matchings/offer-demand-matching';

@Module({
    namespaced: true,
    name: 'OfferDemandModule',
    store,
    dynamic: true,
})

class OfferDemandModule extends VuexModule implements BaseModule {

    public offerDemand: OfferDemand = new OfferDemand();
    public matching: OfferDemandMatching = new OfferDemandMatching();
    public offerDemandList: OfferDemand[] = [];
    public categoryFirstLevelSelect: CategoryFirstLevel = new CategoryFirstLevel();/*.fromJson(window.localStorage.getItem('category'));*/
    public responseAlgorithmList:  MatchingOfferDemand[] = [];
    public fakeData: MatchingOfferDemand = new MatchingOfferDemand();
    public searchResults: any = null;

    @Mutation
    public resetState(): void {
        this.offerDemandList = [];
    }

    @Action
    public async getOffersDemands() {
        if (this.categoryFirstLevelSelect.id !== null && this.categoryFirstLevelSelect.id !== undefined && this.categoryFirstLevelSelect.id > 0) {
            const apiGetOfferDemand = ItiString.Format(API.offerDemandDetail, this.categoryFirstLevelSelect.id);
            const res = await itiHttpService.get(apiGetOfferDemand);
            this.context.commit('updateOffersDemands', res);
        } else {
            this.context.commit('updateOffersDemands', []);
        }
    }

    @Mutation
    public updateOffersDemands(items: OfferDemand[]) {
        this.offerDemandList = items;
    }

    @Action
    public actualizarCategorySelect(item: number | null) {
        this.context.commit('updateCategorySelect', item);
    }

    @Mutation
    public updateCategorySelect(item: number) {
        var category = categoryFirstLevelModule.categories.find(x => x.id == item);
        if (category !== undefined){
            this.categoryFirstLevelSelect = category;
            // window.localStorage.setItem('category', this.categorySelect.toJson());
            // window.localStorage.setItem('category', JSON.stringify(this.categorySelect));
        }
    }

    @Mutation
    public setOfferDemandList(items: OfferDemand[]) {
        this.offerDemandList = items;
    }

    @Action
    public async getOfferDemandList() {        
        const res = await itiHttpService.get(API.offerDemand + '/GetOffersDemands');
        this.context.commit('setOfferDemandList', res);
    }

    @Mutation
    public setOfferDemand(item: OfferDemand) {
        this.offerDemand = item;        
    }

    @Mutation
    public setMatching(item: OfferDemandMatching) {
        this.matching = item;        
    }

    @Action
    public async getOfferDemandById(array: any[]) { 
        var res;       
        if(array[1] == 'offer')
            res = await itiHttpService.get(API.offerDemand + '/GetOfferDemandById?offerId=' + array[0]);
        else
            res = await itiHttpService.get(API.offerDemand + '/GetOfferDemandById?demandId=' + array[0]);

        this.context.commit('setMatching', res);
    }

    @Action 
    public async interested(array: any[]) {
        const url = API.collaborativeArea + '/InterestedIn?algorithmId=' + array[0] + "&isOffer=" + array[1];            
        const res = await itiHttpService.post(url, ""); 
    }

    @Action 
    public async interestedInDemand(algorithmId: number) {
        var interesedtedOfferDemandInput: OfferDemand = new OfferDemand();
        interesedtedOfferDemandInput.id = algorithmId;
        interesedtedOfferDemandInput.interestedDemand = true;        
        interesedtedOfferDemandInput.demandId = this.offerDemand.demandId;
        const url = API.collaborativeArea + '/InterestedIn';            
        const res = await itiHttpService.post(url, interesedtedOfferDemandInput);
    }

    @Action
    public async markCollaborativeAreaCreated(responseAlgorithmId: number) {
        const url = API.collaborativeArea + '/MarkCollaborativeAreaCreated?responseAlgorithmId=' + responseAlgorithmId + '&created=true&collaborativeAreaId=' + collaborativeAreaModule.selectedCollaborativeArea.id;
        const res = await itiHttpService.post(url, null);
    }

    @Mutation
    public setResponseAlgorithmById(item: MatchingOfferDemand) {
        this.responseAlgorithmList.push(item);
    }

    @Action
    public async getResponseAlgorithmById(id: number) {
        const res = await itiHttpService.get(API.responseAlgorithm + '/GetResponseAlgorithmById?id=' + id); 
        this.context.commit('setResponseAlgorithmById', res);      
    }

    @Mutation
    public emptyResponseAlgorithmList() {                        
        this.responseAlgorithmList = [];               
    }

    /* PARA OBTENER DATOS FALSOS Y RELLENAR LA INFORMACI�N QUE FALTA DE LOS ALGORITMOS*/    
    @Mutation
    public setFakeData(item: MatchingOfferDemand) {              
        this.fakeData = item;
    }

    @Action
    public async getFakeData(id: number) {        
        const res = await itiHttpService.get(API.offerDemand + '/GetMatchingOfferDemandById?id=' + id);       
        this.context.commit('setFakeData', res);
    }

    @Action
    public async getAdvancedSearch(search: AdvancedSearch) {
        var url;
        switch(search.level){
            case 1: url = "CategoryFirstLevelCode=" + search.code + '&'; break;
            case 2: url = "CategorySecondLevelCode=" + search.code + '&'; break;
            case 3: url = "CategoryThirdLevelCode=" + search.code + '&'; break;
            case 4: url = "CategoryFourthLevelCode=" + search.code + '&'; break;
            default: url = ''; break;
        }
        url = url + 'Offer=' + search.offer;
        url = url + '&Demand=' + search.demand;
        if(search.description != '') 
            url = url + '&Description=' + search.description;
        if(search.postalCode != '') 
            url = url + '&PostalCode=' + search.postalCode;

        const res = await itiHttpService.post(API.offerDemand + '/AdvancedSearch?' + url,'');       
        this.context.commit('setResultsOfSearch', res);
    }

    @Mutation
    public setResultsOfSearch(res: any) {                        
        this.searchResults = res;
    }

    public createUrlParameters(search: AdvancedSearch){
        
    }

}

export default getModule(OfferDemandModule);